export const apiUrl = process.env.REACT_APP_API_URL || "";

export const empresa = process.env.REACT_APP_EMPRESA || "";

export const environment = process.env.REACT_APP_ENVIRONMENT || "";
